let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fv1Ey")).then(() => parcelRequire('gGeSJ'));